// extracted by mini-css-extract-plugin
module.exports = {"small":"600px","medium":"1024px","large":"1280px","wrapper":"VehicleDetailsContainer_wrapper__tl6ht"};